import React from 'react';
import SecuritySection from './ui/SecuritySection';
import SecurityEmptyState from './ui/SecurityEmptyState';
import { IconAlert } from '../../ui/adminIcons';
import { formatTimestamp, getEventTypeLabel } from '../securityUtils';

function IncidentCard({ title, events, emptyTitle, renderDetail }) {
  return (
    <div className="vx-sec-panel">
      <h3 className="vx-sec-panel-title">{title}</h3>
      {events.length > 0 ? (
        <ul className="vx-sec-incident-list">
          {events.map((event, index) => (
            <li key={event.id || `${event.timestamp}-${index}`} className="vx-sec-incident-item">
              <span className="vx-sec-incident-time">{formatTimestamp(event.timestamp)}</span>
              <span className="vx-sec-incident-ip">{event.ipAddress}</span>
              <span className="vx-sec-incident-detail">{renderDetail(event)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <SecurityEmptyState title={emptyTitle} />
      )}
    </div>
  );
}

export default function SecurityIncidentsPanel({ recentEvents = [] }) {
  const fileEvents = recentEvents
    .filter((e) => e.eventType === 'SENSITIVE_FILE_ACCESS')
    .slice(0, 3);
  const botEvents = recentEvents
    .filter((e) => e.eventType === 'MALICIOUS_BOT_DETECTED' || e.eventType === 'HIGH_RISK_BOT_BEHAVIOR')
    .slice(0, 3);
  const scannerEvents = recentEvents
    .filter((e) => e.eventType === 'SCANNER_DETECTED')
    .slice(0, 3);

  return (
    <SecuritySection title="Recent incidents" icon={<IconAlert />}>
      <div className="vx-sec-grid vx-sec-grid--panels">
        <IncidentCard
          title="File access attempts"
          events={fileEvents}
          emptyTitle="No file access attempts detected"
          renderDetail={(event) => event.endpoint || 'Sensitive file'}
        />
        <IncidentCard
          title="Bot attacks"
          events={botEvents}
          emptyTitle="No malicious bots detected"
          renderDetail={(event) => getEventTypeLabel(event.eventType)}
        />
        <IncidentCard
          title="Scanner activity"
          events={scannerEvents}
          emptyTitle="No scanners detected"
          renderDetail={(event) => (event.userAgent ? `${event.userAgent.substring(0, 40)}…` : 'Unknown agent')}
        />
      </div>
    </SecuritySection>
  );
}
